import React from "react";
import { Tab, Nav } from "react-bootstrap";
import CreateEventRound from "../../Admin/Home/Pages/AdminAudition/AuditionDasboard/Content/CreateEventRound";
import AuditionAssignedStar from "../AuditionAssignedStar/AuditionAssignedStar";
import AuditionRoundDecision from "../Home/Pages/AuditionRoundDecision/AuditionRoundDecision";
import AuditionRoundDecision2 from "../Home/Pages/AuditionRoundDecision/AuditionRoundDecision2";
import AuditionAssignJury from "./AuditionAssignJury/AuditionAssignJury";
import AuditionRoundComplete from "./AuditionRoundComplete/AuditionRoundComplete";
import "./AuditionRounds.css";
import AuditonStarStatus from "./AuditionStarStatus/AuditonStarStatus";
import VideoRound from "./VideoRound/VideoRound";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PendingAuditiontest from "../../Admin/Home/Pages/AdminAudition/AuditionDasboard/Pending/PendingAuditiontest";
import axios from "axios";

const AuditionRounds = () => {
  const [data, setData] = React.useState(0);
  const [loaded, setLoaded] = useState(false);
  const [audition, setAudition] = useState({});
  const [auditionRule, setAuditionRule] = useState({});
  const [auditionJudgeInstructions, setAuditionJudgeInstructions] = useState(
    []
  );
  const [
    activeAuditionJudgeInstructionId,
    setActiveAuditionJudgeInstructionId,
  ] = useState(null);
  const [auditionRoundRules, setAuditionRoundRules] = useState([]);
  const [auditionRoundRule, setAuditionRoundRule] = useState({});
  const [isAllStarResponsed, setIsAllStarResponsed] = useState(false);
  const [isAlreadySubmitted, setIsAlreadySubmitted] = useState(false);
  const [isAnyStarResponsed, setIsAnyStarResponsed] = useState(false);
  let { audition_id } = useParams();

  const getAuditionStatus = () => {
    axios
      .get(`/api/audition-admin/audition/singleAuditionRounds/${audition_id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setAudition(res.data.audition);
          setAuditionRule(res.data.audition_rule);
          setAuditionJudgeInstructions(res.data.audition_judge_instructions);
          setActiveAuditionJudgeInstructionId(
            res.data.active_audition_judge_instruction_id
          );
          setAuditionRoundRules(res.data.audition_round_rules);
          setAuditionRoundRule(res.data.first_audition_round_rule);
          setIsAllStarResponsed(res.data.is_all_star_responsed);
          setIsAnyStarResponsed(res.data.is_any_star_responsed);
          setIsAlreadySubmitted(res.data.is_already_submitted);
          setLoaded(true);
        }
      });
  };
  const handleChangeAuditionRound = (auditionRoundRuleId) => {
    axios
      .get(
        `/api/audition-admin/audition/singleAuditionRoundWithRoundId/${audition_id}/${auditionRoundRuleId}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          setAudition(res.data.audition);
          setAuditionRule(res.data.audition_rule);
          setAuditionJudgeInstructions(res.data.audition_judge_instructions);
          setActiveAuditionJudgeInstructionId(
            res.data.active_audition_judge_instruction_id
          );
          setAuditionRoundRules(res.data.audition_round_rules);
          setAuditionRoundRule(res.data.first_audition_round_rule);
          setIsAllStarResponsed(res.data.is_all_star_responsed);
          setIsAnyStarResponsed(res.data.is_any_star_responsed);
          setIsAlreadySubmitted(res.data.is_already_submitted);
          setLoaded(true);
        }
      });
  };

  useEffect(() => {
    getAuditionStatus();
  }, []);

  return (
    <>
      {loaded === true ? (
        <>
          <div>
            <div className="container-lg">
              <div className="row roundDivStyle">
                {auditionRoundRules &&
                  auditionRoundRules.map((Rule, index) => (
                    <div
                      className="col-md-4"
                      onClick={() => handleChangeAuditionRound(Rule.id)}
                    >
                      <div className="round1Tab mb-2">
                        <div className="px-5 py-2">
                          <h3 className="text-warning">Round</h3>
                          <div className="text-warning  d-flex justify-content-center">
                            <h3 className="bg-dark p-1">{index + 1}</h3>
                          </div>
                        </div>

                        <div
                          className={
                            Rule.id === auditionRoundRule.id
                              ? "roundActive"
                              : "roundInactive"
                          }
                        >
                          {Rule.id == audition.audition_round_rules_id
                            ? "Running"
                            : Rule.id < audition.audition_round_rules_id
                            ? "Completed"
                            : "Pending"}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>

              <div className="my-4">
                {/* if Round is empty then this two component available */}

                {isAlreadySubmitted === false ? (
                  <CreateEventRound
                    audition_id={audition.id}
                    audition_round_id={auditionRoundRule.id}
                    setAuditionJudgeInstructions={setAuditionJudgeInstructions}
                    setIsAllStarResponsed={setIsAllStarResponsed}
                    setIsAnyStarResponsed={setIsAnyStarResponsed}
                    setIsAlreadySubmitted={setIsAlreadySubmitted}
                  />
                ) : (
                  <></>
                )}

                {/* <PendingAuditiontest /> */}

                {/* if Round is empty then this two component available */}

                {/*--------- page no 583--------- */}
                {data === 4 ? (
                  <AuditionAssignedStar data={data} setData={setData} />
                ) : null}

                {/*--------- page no 583--------- */}

                {/*--------- page no 448--------- */}

                {data === 1 ? (
                  <VideoRound data={data} setData={setData} />
                ) : null}
                {/*
            <VideoRound /> */}
                {/*------------ page no 448--------- */}

                {/*--------- page no 451----------*/}
                {/*
            <AuditionAssignJury /> */}
                {data === 2 ? (
                  <AuditionAssignJury data={data} setData={setData} />
                ) : null}
                {/*---------- page no 451 -----------*/}

                {/* pending component start here */}
                {/* <AuditonPending /> */}
                {/* pending component end here */}

                {/*--------- page no 452----------*/}
                {/*
            <AuditonPending /> */}
                {/*---------- page no 452 -----------*/}

                {/*--------- page no 557----------*/}
                {isAnyStarResponsed === true ? (
                  <AuditonStarStatus
                    audition={audition}
                    auditionRoundRule={auditionRoundRule}
                    auditionJudgeInstructions={auditionJudgeInstructions}
                    activeAuditionJudgeInstructionId={
                      activeAuditionJudgeInstructionId
                    }
                    isAllStarResponsed={isAllStarResponsed}
                    data={data}
                    setData={setData}
                    isAlreadySubmitted={isAlreadySubmitted}
                  />
                ) : (
                  <>
                    {isAlreadySubmitted === true ? (
                      <PendingAuditiontest />
                    ) : (
                      <></>
                    )}
                  </>
                )}

                {data === 3 ? (
                  <AuditionRoundDecision data={data} setData={setData} />
                ) : null}

                {data === 5 ? (
                  <AuditionRoundDecision2 data={data} setData={setData} />
                ) : null}
                {data === 6 ? <AuditionRoundComplete /> : null}

                {/*---------- page no 557 -----------*/}
              </div>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default AuditionRounds;
